import React from 'react'

const Flexbox_Coding_Pratice_8 = () => {
  return (
    <div>
      <h1>Flexbox Coding Practice 8</h1>
    </div>
  )
}

export default Flexbox_Coding_Pratice_8
